(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 6141:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(50680);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 41246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21967);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37559);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25925);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70638);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82684);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81990);
/* harmony import */ var _theme_device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40592);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 1;\n  align-self: center;\n  padding: 50px 32px 100px 32px;\n  width: clamp(320px, 100%, 1200px);\n\n  @media ",
        " {\n    max-width: 900px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var PageContentWrapper = function(_param) {
    var className = _param.className, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Wrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        className: className
    }, props), {
        children: children
    }));
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-db8ecefa-0"
})(_templateObject(), _theme_device__WEBPACK_IMPORTED_MODULE_2__/* .device.L */ .U.L);
/* harmony default export */ __webpack_exports__["Z"] = (PageContentWrapper);


/***/ }),

/***/ 50680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var _components_PageContentWrapper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41246);
/* harmony import */ var _components_core_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90656);
/* harmony import */ var _components_NavBar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55270);
/* harmony import */ var _components_core_Heading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96169);
/* harmony import */ var _components_core_NextLink__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96791);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80371);








var NotFoundPage = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_components_NavBar__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_components_PageContentWrapper__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_components_core_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    direction: "column",
                    justifyContent: "center",
                    gap: "48px",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_components_core_Heading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            variant: "h3",
                            children: "Str\xe1nka nebola n\xe1jden\xe1"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_components_core_NextLink__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            href: _routes__WEBPACK_IMPORTED_MODULE_6__/* .routes.root */ ._.root,
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_components_core_Heading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                variant: "h4",
                                withAccentUnderline: true,
                                children: "Prejsť na hlavn\xfa str\xe1nku"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (NotFoundPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7138,5270,9774,2888,179], function() { return __webpack_exec__(6141); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);